import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Avatar, Col, Drawer, Row } from 'antd';
import { RiCloseFill } from 'react-icons/ri';

import AvatarImg from '../../assets/images/placeholder.png';
import HeaderNav from './Header/HeaderNav';
import HeaderLogo from './HeaderLogo';
import { NAV_NDES_CREATE, NAV_RELATIVE_NDES_BASIC_DETAILS } from '../../constants';

const MenuMobile = props => {
  const { onClose, visible } = props;

  return (
    <Drawer
      title={
        <HeaderLogo onClick={onClose} size="full" />
      }
      className="mobile-sidebar"
      placement="left"
      closable={true}
      onClose={onClose}
      visible={visible}
      closeIcon={
        <RiCloseFill
          className="remix-icon text-color-black-80"
          size={24}
        />
      }
    >
      <HeaderNav mode="inline" />

      <Row
        className="sidebar-footer pt-16 mb-16 bg-color-dark-100"
        align="middle"
        justify="center"
      >
        <Col>
          <Link
            to={NAV_NDES_CREATE + NAV_RELATIVE_NDES_BASIC_DETAILS}
            onClick={props.onClose}
          >
            <Avatar size={36} src={AvatarImg} />
          </Link>
        </Col>
      </Row>
    </Drawer>
  );
};

MenuMobile.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func
};

export default MenuMobile;
